export default function Problem() {
  const problems = [
    {
      icon: '×',
      title: '感覚的な予約',
      description: 'PP単価を計算せず、なんとなく路線を選んでしまう。'
    },
    {
      icon: '×',
      title: '制度変更の見落とし',
      description: '途中でルール変更があり、計画が崩壊。やり直しで費用が倍増。'
    },
    {
      icon: '×',
      title: '後戻りできない焦り',
      description: '既に何十万円も使った後で、最適ルートではなかったと気づく。'
    },
    {
      icon: '×',
      title: '仕組みを理解していない',
      description: 'プレミアムポイントの計算式を把握していない'
    },
    {
      icon: '×',
      title: '効率化のコツを知らない',
      description: '表に出ないルールや制約を知らずに損をしている'
    },
    {
      icon: '×',
      title: '明確な設計図がない',
      description: 'SFC修行に潜むリスクを想定していないので計画が甘く、設計が曖昧'
    }
  ];

  return (
    <section id="problem" className="py-32 px-6">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2B4A] text-center leading-tight mb-16">
          なぜ、多くの人が<br />
          50万円以上を使ってしまうのか?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {problems.map((problem, index) => (
            <div key={index} className="bg-white rounded-2xl p-10 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-red-50 rounded-full mb-6">
                <span className="text-3xl font-bold text-red-500">{problem.icon}</span>
              </div>
              <h3 className="text-xl font-semibold text-[#2C2C2C] mb-4">{problem.title}</h3>
              <p className="text-[15px] leading-relaxed text-[#5A5A5A]">{problem.description}</p>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto bg-[#FFF3E0] border-l-4 border-[#FF6F00] rounded-lg p-8">
          <p className="text-lg font-semibold text-[#E65100] text-center">
            SFC修行は一度きり。ダイヤモンド修行は毎年！<br />
            失敗すると数十万円の差が生まれます。
          </p>
        </div>
      </div>
    </section>
  );
}